import { Component, OnInit, OnDestroy } from '@angular/core';
import { OverlayService } from '../../../services/overlay.service';
import { Subscription } from 'rxjs';
import { BeeFreeService } from '../../../services/beefree.service';

@Component({
	selector: 'app-overlay',
	templateUrl: './overlay.component.html',
	styleUrls: ['./overlay.component.scss']
})
export class OverlayComponent implements OnInit, OnDestroy {
	overlayText;
	overlayOn = false;
	subscription: Subscription;
	overlayType;
	isBeeFree: boolean;

	constructor(private overlay: OverlayService, private beeFree: BeeFreeService) {}

	ngOnInit() {
		this.isBeeFree = this.beeFree.isBeeFreeAddon();
		this.subscription = this.overlay.overlayData.subscribe((callback) => {
			this.overlayOn = callback.active;
			this.overlayText = callback.text;
			this.overlayType = callback.type;
		});
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	dismissAlert() {
		this.overlay.updateOverlay(false);
	}

	cancelBeeFree() {
		this.beeFree.cancelAddon();
	}
}
